import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import styles from "./Breadcrumbs.scss";
import { Clickable } from "../../button/Clickable";
import { Icon } from "../../graphic";

export const Crumb = ({ icon, link, label, active }) => {
    return (
        <div
            className={classNames(styles.crumb, {
                [styles.active]: active
            })}
        >
            <div className={styles.wrapper}>
                <Clickable block className={styles.label} link={link}>
                    {icon ? (
                        <div className={styles.icon}>
                            <Icon name={icon} />
                        </div>
                    ) : null}
                    {label}
                </Clickable>
                <div className={styles.arrow}>
                    <Icon name="chevron-right" />
                </div>
            </div>
        </div>
    );
};

Crumb.propTypes = {
    /**
     * Icon
     */
    icon: PropTypes.string,
    /**
     * Link back to the given page
     */
    link: PropTypes.string,
    /**
     * Crumb label
     */
    label: PropTypes.string
};
